import React from "react";
import ArcGauge from "./ArcGauge";
import Confetti from "./Confetti";
import CountUp from "./CountUp";
import { formatCurrency } from "../utils/format";
import { heatColor, reachedColors } from "../utils/heatColor";

// Het blok bovenaan: meter, bedragen en voortgangsbalk.

// Bedrag dat naar zijn nieuwe waarde optelt.
const Figure = ({ label, value, extra = false }) => (
  <div className={`hero-fig${extra ? " is-extra" : ""}`}>
    <div className="k">{label}</div>
    <div className="v">
      {extra && "+"}€<CountUp value={value || 0} format={formatCurrency} />
    </div>
  </div>
);

// Boven het target kleurt het getal van wit naar goud, helemaal goud bij 200%.
const gold = [255, 196, 31];

function GoldTint(percent) {
  const t = Math.min(100, Math.max(0, percent - 100)) / 100;
  return `rgb(${gold.map((v) => Math.round(255 + (v - 255) * t)).join(", ")})`;
}

const TeamTargetHero = ({ monthLabel, teamTarget, amount, progress }) => {
  const { hasTarget, percent, remaining, daysLeft, perDay } = progress;
  // Zonder bekend target nooit "gehaald", ook niet bij een mislukte call.
  const reached = hasTarget && percent >= 100;
  const extra = reached ? Math.max(0, amount - teamTarget.amount) : 0;

  return (
    <section className="hero">
      {reached && <Confetti />}

      <div className={`hero-gauge${reached ? " is-complete" : ""}`}>
        <ArcGauge percent={percent} size={400} stroke={26} reached={reached} />
        <div className="gauge-readout">
          <b style={reached ? { color: GoldTint(percent) } : undefined}>
            <CountUp value={percent} />
            <em>%</em>
          </b>
          <span>
            {!hasTarget
              ? "TARGET ONBEKEND"
              : reached
                ? "TARGET GEHAALD"
                : "VAN TARGET"}
          </span>
        </div>
      </div>

      <div className="hero-main">
        <div className="hero-top">
          <h2 className="hero-title">Team target · {monthLabel}</h2>
          <div className="hero-badge">
            {reached ? (
              <span className="hero-badge-label is-reached">
                <svg viewBox="0 0 16 16" aria-hidden="true">
                  <circle cx="8" cy="8" r="8" />
                  <path d="M4.5 8.2 7 10.6l4.6-5" />
                </svg>
                Uitje verdiend
              </span>
            ) : (
              <span className="hero-badge-label">Uitje bij 100%</span>
            )}
            <span className="hero-badge-value">
              {teamTarget.text || "Nog niet bekend"}
            </span>
          </div>
        </div>

        <div className="hero-figs">
          <Figure label="Bedrag" value={amount} />
          {reached ? (
            <Figure label="Extra" value={extra} extra />
          ) : (
            <Figure label="Te gaan" value={hasTarget ? remaining : 0} />
          )}
          <Figure label="Target" value={hasTarget ? teamTarget.amount : 0} />
        </div>

        <div className="hero-bar">
          <div className="track">
            {/* Gehaald: hetzelfde wit als de meter. */}
            <i
              className={reached ? "is-reached" : undefined}
              style={{
                width: `${Math.min(100, percent)}%`,
                background: reached
                  ? `linear-gradient(90deg, ${reachedColors.join(", ")})`
                  : `linear-gradient(90deg, ${heatColor(percent * 0.5)}, ${heatColor(percent)})`,
                boxShadow: reached
                  ? "none"
                  : `0 0 ${4 + 8 * (percent / 100)}px ${heatColor(percent, 0.5)}`,
              }}
            />
          </div>
          <div className="hero-meta">
            <span>{daysLeft} dagen te gaan</span>
            <span>
              €<CountUp value={perDay || 0} format={formatCurrency} /> per dag nodig
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamTargetHero;
